import React, { useContext, useState } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, FormLabel, Input, Flex, Button, useToast, } from "@chakra-ui/react";
import SwitchStyle from "./ToggleSwitch.module.css";
import { BeatLoader } from 'react-spinners';
import { CentralizeStore } from '../../contexts/CentralizeStoreProvider';
import uploadService from '../../api/uploadService';
import CustomToast from '../../reusable-components/Toaster/CustomToast';

const CreateFolderModal = (props) => {
    const {isOpen, onClose, handleReFetch} = props;
    const {parentPath, parentPathId} = useContext(CentralizeStore)
    const [folderName, setFolderName] = useState("");
    const [isPublic, setIsPublic] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const storedEmail = localStorage.getItem("email");
    const storedRole = localStorage.getItem("role");
    const comp_id = localStorage.getItem("comp_id");
    const department_id = localStorage.getItem("department_id");
    const toast = useToast();

    const handlePrivacyChange = (e) => {
      setIsPublic(e.target.checked);
    };

    const handleCreateFolder = async (e) => {
        e.preventDefault();

        try{
          setIsLoading(true);
          const payload = {
            comp_id: comp_id,
            folder_name: folderName,
            parent_path: parentPathId,
            email:storedEmail,
            department_id: department_id,
            scope: isPublic ? 1 : 0,
            role: storedRole
          }
          // console.log("pay:", payload)
          const res = await uploadService.createFolder(payload)
          if(res.status === 200) {
            toast({
              render: ({ onClose }) => (
                <CustomToast title={`${res?.data?.Message}`} status="success" onClose={onClose} />
              ),position: "top", duration: 3000, isClosable: true,
             })
            handleCloseModal()
            handleReFetch();
          }
          console.log("after create:", res)

        }catch(err){
          console.log("err:", err)
        }finally{
          setIsLoading(false)
        }
    }

    const onChangeFolderName = (e) => {
      const value = e.target.value;
      const regex = /^[a-zA-Z0-9 _-]*$/;
  
      if (regex.test(value)) {
        setFolderName(value);
      }
    }

    const handleCloseModal = () => {
      setFolderName("");
      setIsPublic(false);
      onClose();
    }

  return (
    <div>
      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Create Folder
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <form onSubmit={handleCreateFolder}>
            <FormLabel>Folder Name <span className='required_sym'>*</span></FormLabel>
            <Input required type="text" value={folderName} onChange={onChangeFolderName}/>
            {/* <FormLabel>Scope</FormLabel>
            <Flex w={"100%"} alignItems="center" justifyContent="flex-start">
									<span>Private</span>
									<div className={SwitchStyle.checkbox_apple}>
										<input
											className={SwitchStyle.yep}
											id="check-apple"
											type="checkbox"
											checked={isPublic}
											onChange={handlePrivacyChange}
										/>
										<label htmlFor="check-apple"></label>
									</div>
									<span>Public</span>
								</Flex> */}
                <Flex alignItems={"flex-end"} justifyContent={"flex-end"} gap={"10px"} mt={4}>
            <Button isDisabled={isLoading} type='submit' size={"sm"} id="btn" mr={3}>
              {isLoading ? <BeatLoader color='#FFFFFF' /> : "Submit"}
            </Button>
            <Button size={"sm"} variant={"outline"} colorScheme={"red"} onClick={handleCloseModal}>Cancel</Button>
            </Flex>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default CreateFolderModal
